const materialsEquipmentRequestStatus = {
  Nuevo: 1,
  Sometido: 2,
  DevueltoEscuela: 3,
  Aprobada: 4, //Nombre friendly para estado Pendiente de Análisis de Requisición
  PendienteClasificacion: 6,
};

const materialsEquipmentRequestStatusString = {
  1: 'Nuevo',
  2: 'Sometido',
  3: 'Devuelto a la Escuela',
  4: 'Aprobado',
  6: 'Pendiente de Clasificación',
};

export {
  materialsEquipmentRequestStatus,
  materialsEquipmentRequestStatusString,
};
